import { formatDatePickerDate } from './formatting';

export const areDatesInvalid = (startDate?: Date | string, endDate?: Date | string) => {
  if (!endDate) {
    return false;
  }

  if (!startDate) {
    startDate = new Date().toISOString().slice(0, 10);
  }

  if (startDate.toString().includes('/') && !endDate.toString().includes('/')) {
    return new Date(startDate) > new Date(formatDatePickerDate(endDate));
  } else if (endDate.toString().includes('/') && !startDate.toString().includes('/')) {
    return new Date(formatDatePickerDate(startDate)) > new Date(endDate);
  }

  return startDate > endDate;
};
